/* Premium weighted scroll (Lenis) — desktop + motion-OK only. Native scroll on
   touch (better momentum) and for reduced-motion. Pauses while a drawer/menu is open. */
(function () {
  if (typeof Lenis === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return; // touch -> native
  var lenis = new Lenis({
    duration: 1.05,
    easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }, // expo-out, weighted
    smoothWheel: true
  });
  window.__lenis = lenis;
  function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
  requestAnimationFrame(raf);

  // Pause smooth-scroll while the cart drawer / mobile menu locks the body.
  var obs = new MutationObserver(function () {
    if (document.body.classList.contains('overflow-hidden')) lenis.stop(); else lenis.start();
  });
  obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // Smooth in-page anchor links.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href');
    if (!id || id.length < 2) return;
    var el = document.querySelector(id);
    if (!el) return;
    e.preventDefault();
    lenis.scrollTo(el, { offset: -80 });
  });
})();
